import { stringify } from 'query-string';
import * as APIRoutes from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { ObjectUtils } from '@mm/utils';
import {
  CampaignOverviewKindType,
  CampaignsOverviewPayload,
} from '../model/CampaignOverviewModel';

const defaultPagingObj = {
  page: 1,
  perPage: 8,
};

export type CampaignsOverviewPaginationParams = typeof defaultPagingObj;

export class CampaignsOverviewController extends AuthenticatedController {
  static async getAll({
    botId,
    kind,
    search,
    pagination = defaultPagingObj,
    ids,
  }: {
    botId: number;
    kind: CampaignOverviewKindType;
    search?: string;
    pagination?: CampaignsOverviewPaginationParams;
    ids?: number[];
  }): Promise<CampaignsOverviewPayload> {
    const queryObj = ObjectUtils.deepSnakeKeys({
      ...pagination,
      kind,
      query: search,
      ids,
    });
    const query = `?${stringify(queryObj)}`;
    const path = `${APIRoutes.CAMPAIGNS_OVERVIEW({ botId })}${query}`;
    return super.get(path);
  }
  static async retrieveEnabledInputTriggers(botId: number) {
    const path = `${APIRoutes.ENABLED_INPUT_TRIGGERS({ botId })}`;
    return super.get(path);
  }
}
